import i18next from 'i18next'
import {OnlinePaymentStatus, posStatusTabKeys} from '@/constants'

export const statuses = () => [OnlinePaymentStatus.auth, OnlinePaymentStatus.charge, OnlinePaymentStatus.cancel, OnlinePaymentStatus.refund].map((status) => ({
    value: status,
    label: status ? i18next.t(`enums:onlinePaymentStatus.${status}`, { defaultValue: status }) : ''
}))

export const posStatuses = () => posStatusTabKeys.map((status) => ({
    value: status,
    label: status ? i18next.t(`enums:posPaymentStatus.${status}`, { defaultValue: status }) : ''
}))
